/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderByParams
 */
export interface OrderByParams {
    /**
     * 
     * @type {string}
     * @memberof OrderByParams
     */
    term: OrderByParamsTermEnum;
    /**
     * Sort order: asc or desc. Ignored if term="relevance".
     * @type {string}
     * @memberof OrderByParams
     */
    order: string;
    /**
     * Center point latitude. Provide if you want to sort by distance from a point (term = "distance").
     * @type {number}
     * @memberof OrderByParams
     */
    latitude: number;
    /**
     * Center point longitude. Provide if you want to sort by distance from a point (term = "distance").
     * @type {number}
     * @memberof OrderByParams
     */
    longitude: number;
}


/**
 * @export
 */
export const OrderByParamsTermEnum = {
    Relevance: 'relevance',
    Distance: 'distance',
    Price: 'price',
    Listdate: 'listdate',
    Solddate: 'solddate',
    Livingspace: 'livingspace',
    Lotsize: 'lotsize'
} as const;
export type OrderByParamsTermEnum = typeof OrderByParamsTermEnum[keyof typeof OrderByParamsTermEnum];


/**
 * Check if a given object implements the OrderByParams interface.
 */
export function instanceOfOrderByParams(value: object): value is OrderByParams {
    if (!('term' in value) || value['term'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function OrderByParamsFromJSON(json: any): OrderByParams {
    return OrderByParamsFromJSONTyped(json, false);
}

export function OrderByParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderByParams {
    if (json == null) {
        return json;
    }
    return {
        
        'term': json['term'],
        'order': json['order'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function OrderByParamsToJSON(json: any): OrderByParams {
    return OrderByParamsToJSONTyped(json, false);
}

export function OrderByParamsToJSONTyped(value?: OrderByParams | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'term': value['term'],
        'order': value['order'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

